module.exports = __webpack_public_path__ + "fonts/Barlow-Italic.42c116b2.woff2";